<section>
  <nz-card>
    <nz-skeleton [nzTitle]="false" [nzParagraph]="{ rows: 1 }" [nzActive]="true"></nz-skeleton>
    <div class="grid min-[500px]:grid-cols-2 lg:grid-cols-4 gap-2 mt-5">
      <nz-space nzSize="middle" *ngFor='let in of counter(12) ;let i = index' [ngClass]="i < 6 ? 'hidden min-[500px]:block' : ''">
        <nz-skeleton-element *nzSpaceItem nzType="input" [nzActive]="true" [nzSize]="'default'" ></nz-skeleton-element>
      </nz-space>
    </div>
  </nz-card>
</section>

<section class="mt-8">
  <nz-card>
    <nz-skeleton [nzTitle]="false" [nzParagraph]="{ rows: 1 }" [nzActive]="true"></nz-skeleton>
    <div class="grid min-[500px]:grid-cols-2 lg:grid-cols-4 gap-2 mt-5">
      <nz-space nzSize="middle" *ngFor='let in of counter(12) ;let i = index' class="{{i < 6 ? 'hidden min-[500px]:block' : ''}}">
        <nz-skeleton-element *nzSpaceItem nzType="input" [nzActive]="true" [nzSize]="'default'" ></nz-skeleton-element>
      </nz-space>
    </div>
  </nz-card>
</section>

<section class="mt-8">
  <nz-card>
    <div class="flex flex-row justify-end">
      <div class="flex gap-4">
        <nz-space nzSize="middle">
          <nz-skeleton-element *nzSpaceItem nzType="button" [nzShape]="'round'" [nzActive]="true"></nz-skeleton-element>
        </nz-space>
        <nz-space nzSize="middle">
          <nz-skeleton-element *nzSpaceItem nzType="button" [nzShape]="'round'" [nzActive]="true"></nz-skeleton-element>
        </nz-space>
      </div>
    </div>
  </nz-card>
</section>
